import API from './apiInstance';

export const getURLById = (id: number) : any => API.get(`/api/url/get-url-by-id?id=${id}`);
export const createURL = (payload: any) => API.post('/api/url/create', payload);
export const updateURL = (payload: any) => API.put('/api/url/update-url', payload);
export const deleteURL = (id: number) => API.delete(`/api/url/delete/${id}`);
export const listURLs = (payload: any): any => API.post(`/api/url/list-url?${payload}`);
